<template>
    <div id="app">
        <div class="wrapper flex1" v-if="ready">
            <router-view />
        </div>
        <div v-if="!ready" class="flex1" v-loading="true"></div>
    </div>
</template>

<script>
    import ssoService from '../services/sso.service';
    import create from '../../src/core/utils/request.js'

    import  Vue from 'vue';
    export default {
        name: 'app',
        data() {
            return {
                ready: false,
            }
        },
        computed:{
            user_id(){
                let user = window.localStorage.getItem('wedof_itsm_web_user_name')?window.localStorage.getItem('wedof_itsm_web_user_name'):this.$cookies.get('user_name')
                return user
            }
        },
        watch: {
            user_id: {
                handler(newName, oldName) {
                    if(!newName) {
                        location.href='#/login'
                    }

                },
                // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
                immediate: true
            }
        },
        created(){

            Vue.eventEmitter.on('user_invalid', () => {
                let _this = this;
                setTimeout(function () {
                    // location.hash = '#/login'
                    _this.$router.replace('login');
                },1000);
            });
            this.init()
            // if(!this.user_id){
            //     location.href='#/login'
            // }else{
            //     this.$store.dispatch('getAuth',{app_name:'itsm',user_id})
            //     this.$store.dispatch('getDictionary');   // 获取全部的数据字典
            //     this.$store.dispatch('getDictionary2');   // 获取全部的CICD数据字典
            //     this.$store.dispatch('getCaseType');     // 所有的类型id
            // }
        },
        mounted () {
        },
        methods:{
            init(){
                // console.log('init')
                window.localStorage.removeItem("wedof-itsm_skin");
                ssoService.logined({ userName: this.user_id }).then((data) => {
                    this.$store.commit('setUserInfo', data);
                    ssoService.UserRoles({app_name:'itsm',user_id: this.user_id}).then((result) => {
                        // console.log(result,'APP.vue里的role');
                        this.$setRoles(result);
                        // console.log(location.href)
                        window.localStorage.setItem('routerLink', location.href)
                        this.ready = true;
                    }).catch(err => {
                        this.$message.error(err.message);
                        this.ready = true;
                        this.$router.replace('login');
                    });

                }).catch((err) => {
                    console.log('validate失败了');
                    window.sessionStorage.setItem('routerLink', location.href);
                    location.href='#/login'
                    this.ready = true;
                })

                window.localStorage.getItem('name') || ssoService.setUserInfo().then((res) => {
                    window.localStorage.setItem('wedof_itsm_web_token', this.$cookies.get('token'));
                    window.localStorage.setItem('wedof_itsm_web_user_name', this.$cookies.get('user_name'));
                    for (let i in res) {
                        window.localStorage.setItem(i, res[i]);
                    }

                }).catch((err) => {
                    this.$router.replace('login');
                    this.ready = true;
                })
            }
        }

    }
</script>

<style>
</style>
